/**
 * Extracts a human-readable error message from an HttpErrorResponse.
 * Handles the different shapes Angular produces for the error body:
 * - plain text (string) in `error.error`
 * - JSON `{ error: "msg" }` in `error.error.error`
 * - non-JSON text Angular stores in `error.error.text`
 * Falls back to the provided message when none is present.
 */
export function getErrorMessage(error: any, fallback: string): string {
  const body = error?.error;

  if (typeof body === 'string' && body.trim()) {
    return body;
  }
  if (typeof body?.error === 'string' && body.error.trim()) {
    return body.error;
  }
  if (typeof body?.text === 'string' && body.text.trim()) {
    return body.text;
  }
  return fallback;
}
